import Header from "./Header";
import Footer from "./Footer";

import logo from "../../logo.avif"

import storeFront from "../../Photos/127_storeFront.jpg";
import IMG1 from "../../Photos/127_IMG_1.jpg";
import IMG2 from "../../Photos/127_IMG_2.jpg";
import IMG3 from "../../Photos/127_IMG_3.jpg";
import IMG4 from "../../Photos/127_IMG_4.jpg";


const people = [
    {
        id: '1',
        name: 'Paula Weinert',
        role: 'President and Co-Founder',
        imageUrl: '',
        bio: 'Paula had a nursing background and never intended to begin fostering children. She was raising four of her own children and felt that would be enough. Paula and her husband, Tom, had every excuse in the book regarding why they should not become foster parents. However, a family opportunity presented itself and Paula just could not say no. That began the Weinert family fostering journey. Many children have come through their home and their family was impacted immensely by each and every one. Paula\'s dream of Bridge 127 began when her now 8-year-old autistic son was brought to them at only 8-1/2 months old with nothing more than a diaper and a punch filled baby bottle. She wanted to give more than just a home. She wanted to provide mentorship for these youth as well as other foster moms and biological moms.',
    },
    {
        id: '2',
        name: 'Anonymous',
        role: 'Co-Founder',
        imageUrl: '',
        bio: 'This co-founder, although being an active participant in the establishment of Bridge 127, requests to remain confidential.',
    },
    {
        id: '3',
        name: 'Susan Belsak',
        role: 'Community Outreach Coordinator',
        imageUrl: '',
        bio: 'Susan is a former RN working in the mental health field.  She also worked as a training and sales manager for a major corporation for 25 years.  Susan was instrumental in organizing the Orwigsburg Food Pantry and God\'s Helping Hands ministry, both servicing Schuylkill County.  Her interests include making connections in the community to coordinate services with clients as needs arise.',
    },
    {
        id: '4',
        name: 'Thomas Weinert, Jr.',
        role: 'Planned Giving Director',
        imageUrl: '',
        bio: 'Thomas is an avid golfer and loves his career in sales.  Thomas became a foster father and eventual adoptive father reluctantly along with his wife, Paula.  The foster care journey has changed his life and opened his eyes to the needs around him in his own backyard.  He loves to use his sales skills to educate others about the needs of high risk youth, in and out of foster care.',
    },


    {
        id: '5',
        name: 'Kerri Weikel',
        role: 'Boutique Manager',
        imageUrl: '',
        bio: 'Description to Come Soon',
    },
    {
        id: '6',
        name: 'Tammy Munster',
        role: 'Personal Shopper',
        imageUrl: '',
        bio: 'Description to Come Soon',
    },
    // More people...
]


const About = () => {

    return (
        <div className="bg-white h-screen">
            {/* Header */}
            <Header/>

            <main className="isolate mb-10">

                {/*Landing*/}
                <div className="relative isolate pt-14">
                    <div
                        aria-hidden="true"
                        className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
                    >
                        <div
                            style={{
                                clipPath:
                                    'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                            }}
                            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-skyBlue to-blue-400 opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
                        />
                    </div>
                    <div className="py-24 sm:py-32 lg:pb-40">
                        <div className="mx-auto max-w-7xl px-6 lg:px-8">
                            <div className="mx-auto max-w-3xl text-center">
                                <h1 className="text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
                                    Bridging the Gap in the <br/> Child Care System
                                </h1>
                                <p className="mt-8 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
                                    We encourage awareness and community participation in support of high risk youth as
                                    well as the families that care for them.
                                </p>
                                <div className="mt-10 flex items-center justify-center gap-x-6">
                                    <a
                                        href="/contact"
                                        className="rounded-md bg-blue-400 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-skyBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                    >
                                        Get In Touch
                                    </a>
                                    <a href="https://app.aplos.com/aws/give/Bridge127" className="text-sm/6 font-semibold hover:scale-105 text-gray-900">
                                        Please Donate <span aria-hidden="true">→</span>
                                    </a>
                                </div>
                            </div>
                            <div className="mt-16 flow-root sm:mt-24">
                                <div
                                    className="-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4">
                                    <img
                                        alt="App screenshot"
                                        src={storeFront}
                                        width={2432}
                                        height={1442}
                                        className="rounded-md shadow-2xl ring-1 ring-gray-900/10"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        aria-hidden="true"
                        className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
                    >
                        <div
                            style={{
                                clipPath:
                                    'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                            }}
                            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-skyBlue to-blue-400 opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
                        />
                    </div>
                </div>

                {/*Our Mission*/}
                <div className="overflow-hidden bg-white py-24 sm:py-32">
                    <div className="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">
                        <div className="max-w-4xl">
                            <p className="text-base/7 font-semibold text-blue-600">Our Mission</p>
                            <h1 className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                                Our Humble Beginnings
                            </h1>
                            <p className="mt-6 text-balance text-md/8 text-gray-700">
                                Bridge 127 began with the dreams of two foster moms who were tired of seeing foster children walk into their homes with a garbage bag full of clothing that generally did not even fit.  They dreamed of providing these foster youth with a boutique shopping experience that would provide them with personal belongings that they could choose themselves and that nobody was going to take away.  These children already had so much taken away to no fault of their own.
                            </p>
                        </div>
                        <section className="mt-20 grid grid-cols-1 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-16">
                            <div className="lg:pr-8">
                                <h2 className="text-pretty text-2xl font-semibold tracking-tight text-gray-900">Our
                                    mission</h2>
                                <p className="mt-6 text-base/7 text-gray-600">
                                    Our children today are often removed from their homes, are homeless, or move from one place to another never knowing how long they will be staying. Often, these children have nothing to call their own. They face rejection, neglect, abuse, and abandonment.
                                </p>
                                <p className="mt-8 text-base/7 text-gray-600">
                                    Bridge 127, Inc. in Pottsville, Pennsylvania partners with local child welfare agencies to assist high risk youth, make placement transitions easier, and to assist aged-out youth as they gain independence.
                                </p>
                            </div>

                            {/*Images*/}
                            <div className="pt-16 lg:row-span-2 lg:-mr-16 xl:mr-auto">
                                <div className="-mx-8 grid grid-cols-2 gap-4 sm:-mx-16 sm:grid-cols-4 lg:mx-0 lg:grid-cols-2 lg:gap-4 xl:gap-8">
                                    <div className="aspect-square overflow-hidden rounded-xl shadow-xl outline outline-1 -outline-offset-1 outline-black/10">
                                        <img
                                            alt=""
                                            src={IMG1}
                                            className="block size-full object-cover"
                                        />
                                    </div>
                                    <div className="-mt-8 aspect-square overflow-hidden rounded-xl shadow-xl outline outline-1 -outline-offset-1 outline-black/10 lg:-mt-40">
                                        <img
                                            alt=""
                                            src={IMG2}
                                            className="block size-full object-cover"
                                        />
                                    </div>
                                    <div className="aspect-square overflow-hidden rounded-xl shadow-xl outline outline-1 -outline-offset-1 outline-black/10">
                                        <img
                                            alt=""
                                            src={IMG3}
                                            className="block size-full object-cover"
                                        />
                                    </div>
                                    <div className="-mt-8 aspect-square overflow-hidden rounded-xl shadow-xl outline outline-1 -outline-offset-1 outline-black/10 lg:-mt-40">
                                        <img
                                            alt=""
                                            src={IMG4}
                                            className="block size-full object-cover"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/*The Numbers*/}
                            <div className="max-lg:mt-16 lg:col-span-1">
                                <p className="text-base/7 font-semibold text-blue-600">The results</p>
                                <hr className="mt-6 border-t border-gray-200"/>
                                <dl className="mt-6 grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
                                    <div className="flex flex-col gap-y-2 border-b border-dotted border-gray-200 pb-4">
                                        <dt className="text-sm/6 text-gray-600">Items Donated</dt>
                                        <dd className="order-first text-6xl font-semibold tracking-tight">
                                            +<span>50</span>K
                                        </dd>
                                    </div>
                                    <div className="flex flex-col gap-y-2 border-b border-dotted border-gray-200 pb-4">
                                        <dt className="text-sm/6 text-gray-600">Youth Helped 2024</dt>
                                        <dd className="order-first text-6xl font-semibold tracking-tight">
                                            <span>1034</span>
                                        </dd>
                                    </div>
                                    <div
                                        className="flex flex-col gap-y-2 max-sm:border-b max-sm:border-dotted max-sm:border-gray-200 max-sm:pb-4">
                                        <dt className="text-sm/6 text-gray-600">Youth Helped 2023</dt>
                                        <dd className="order-first text-6xl font-semibold tracking-tight">
                                            <span>747</span>
                                        </dd>
                                    </div>
                                    <div className="flex flex-col gap-y-2">
                                        <dt className="text-sm/6 text-gray-600">Youth Helped 2022</dt>
                                        <dd className="order-first text-6xl font-semibold tracking-tight">
                                            <span>581</span>
                                        </dd>
                                    </div>
                                </dl>
                            </div>

                        </section>
                    </div>
                </div>

                {/*Team*/}
                <div className="bg-white py-24 md:py-32 lg:py-40">
                    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-20 px-6 lg:px-8 xl:grid-cols-3">
                        <div className="mx-auto max-w-2xl lg:mx-0">
                            <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Our
                                team</h2>
                            <p className="mt-6 text-lg/8 text-gray-600">
                                We’re a dynamic group of individuals who are passionate about what we do and dedicated
                                to delivering the best results for our local at risk youth.
                            </p>
                        </div>
                        {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
                        <ul
                            role="list"
                            className="mx-auto grid max-w-2xl grid-cols-1 gap-x-6 gap-y-20 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:gap-x-8 xl:col-span-2"
                        >
                            {people.map((person) => (
                                <li key={person.id}>
                                    <img alt="" src={person.imageUrl || logo}
                                         className="aspect-[3/2] w-full rounded-2xl object-cover"/>
                                    <h3 className="mt-6 text-lg/8 font-semibold text-gray-900">{person.name}</h3>
                                    <p className="text-base/7 text-gray-600">{person.role}</p>
                                    <p className="mt-4 text-base/7 text-gray-600">{person.bio}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

            </main>

            {/* Footer */}
            <Footer/>

        </div>
    )
};

export default About;
